import Layout from '@layouts/VerticalLayout'
import CustomNavbar from './components/Navbar'
import useEmbed from '@hooks/useEmbed'

const VerticalLayout = props => {
  const { isEmbed } = useEmbed()

  return (
    <Layout
      navbar={isEmbed ? null : props => <CustomNavbar {...props} />}
      footer={props => <></>}
      {...props}
    >
      {props.children}
    </Layout>
  )
}

export default VerticalLayout
